<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      @if (this.state.isBigScreen && this.reportId == null) {
      <ion-button (click)="createDraft()"
        >@if(reports.length > 1){ {{ "reports.saveDrafts" | translate }} }@else{
        {{ "reports.saveDraft" | translate }} }</ion-button
      >
      } @if ( this.state.isBigScreen && this.reportId != null &&
      this.reports[0].isDraft ) {
      <ion-button (click)="createDraft()">{{
        "reports.updateDraft" | translate
      }}</ion-button>
      } @if (this.reportId == null || this.reports[0].isDraft) {
      <ion-button
        [disabled]="errorList.length > 0 || sendButtonDisabled"
        (click)="sendToBackend()"
        >{{
          "reports.submitReport" | translate : { report: reportTypeSubmitLabel }
        }}</ion-button
      >
      } @if (this.reportId != null && !this.reports[0].isDraft) {
      <ion-button [disabled]="errorList.length > 0" (click)="sendToBackend()">{{
        "reports.updateReport" | translate : { report: reportTypeLabel }
      }}</ion-button>
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="background-container">
    @if(!reportId){
    <div class="segment-container">
      <ion-segment
        mode="ios"
        [(ngModel)]="reportType"
        (ionChange)="changeReportTypeLabel()"
      >
        <ion-segment-button [value]="ConstructionDayReportType.$0">
          <ion-label>{{ "reports.daily" | translate }}</ion-label>
          <ion-icon style="font-size: 24px" name="clipboard-outline"></ion-icon>
        </ion-segment-button>
        <ion-segment-button [value]="ConstructionDayReportType.$1">
          <ion-label>{{ "reports.trip" | translate }}</ion-label>
          <ion-icon
            style="font-size: 24px"
            name="speedometer-outline"
          ></ion-icon>
        </ion-segment-button>
        <ion-segment-button [value]="ConstructionDayReportType.$2">
          <ion-label>{{ "reports.work" | translate }}</ion-label>
          <ion-icon style="font-size: 24px" name="time-outline"></ion-icon>
        </ion-segment-button>
      </ion-segment>
    </div>
    } @for (report of reports;track report; let reportIndex = $index) {
    <div class="box-container">
      @if(!reportId){
      <div class="box-container-caption">
        <div>
          {{
            "reports.numberedReport"
              | translate : { report: reportTypeLabel, number: reportIndex + 1 }
          }}
        </div>
        @if(reports?.length > 1){
        <ion-icon
          style="margin-right: 14px; font-size: 26px; cursor: pointer"
          name="trash-outline"
          (click)="removeReport(reportIndex)"
        ></ion-icon>
        }
      </div>
      }

      <div class="select-form wide" style="margin-top: 15px">
        <lib-date-time-picker
          [type]="'date'"
          [inputDateZulu]="report.date"
          (selectedDateChanged)="dateChanged($event, report)"
        ></lib-date-time-picker>
        @if(reportType == ConstructionDayReportType.$0){

        <ion-button (click)="showAudioInput = !showAudioInput">
          @if(showAudioInput){
          <ion-icon
            name="pencil-outline"
            class="white"
            aria-hidden="true"
          ></ion-icon
          >}@else{<ion-icon
            name="mic-outline"
            class="white"
            aria-hidden="true"
          ></ion-icon
          >}</ion-button
        >}
      </div>
      @if(weekendOrPublicHolidaySelected(report.date)){
      <div class="select-form no-workday-warning">
        <div class="centered">
          <ion-icon
            size="small"
            name="information-circle-outline"
            style="margin-right: 4px"
          ></ion-icon>
          {{ "reports.weekendSelected" | translate }}
        </div>
      </div>
      } @if(showAudioInput){
      <lib-audio-recorder
        (recordingCreated)="recordingCreated($event, reportIndex)"
      ></lib-audio-recorder>
      } @if(!showAudioInput){
      <div class="select-form">
        <lib-construction-site-picker
          [conSites]="this.state.conSites$"
          [multiple]="false"
          (selectedConSiteChanged)="conSiteChange($event, report)"
          [preselectedConSite]="report.constructionSite"
        ></lib-construction-site-picker>
      </div>
      <div class="select-form">
        <lib-user-picker
          [preselectedUsers]="report.responsibleWorker"
          [users]="this.state.users$"
          [isResponsible]="reportType != ConstructionDayReportType.$1"
          [isDriver]="reportType == ConstructionDayReportType.$1"
          [showAllEntry]="false"
          (selectedUserChanged)="responsibleWorkerChange($event, report)"
        ></lib-user-picker>
      </div>

      <div class="box-header">
        @if(reportType == ConstructionDayReportType.$1){
        {{ "reports.tripTimes" | translate }} }@else {
        {{ "reports.siteWorkingTimes" | translate }} }
      </div>

      <div class="working-hours">
        @if(reportType != ConstructionDayReportType.$0){ @if (
        userHasOtherConSiteWorkingTimes(report.responsibleWorker, report) ) {
        <div class="other-bookings">
          <div>{{ "reports.alreadyBooked" | translate }}</div>
          @for ( entry of getOtherConSiteWorkingTimes( report.responsibleWorker,
          report ) ; track entry) {
          <div>
            {{ entry }}
          </div>
          }
        </div>
        } @if (userHasWorkingTimes(report.responsibleWorker, report)) {
        <div class="suggestions">
          @for ( entry of getThisConSiteWorkingTimes( report.responsibleWorker,
          report ) ; track entry) {
          <div class="wide">
            <div>{{ getBeautifiedString(entry) }}</div>
            <ion-button
              (click)="takeUserHours(report.responsibleWorker, entry, report)"
              >{{ "reports.adoptHours" | translate }}</ion-button
            >
          </div>
          }
        </div>
        } }
        <div class="custom-table">
          <div class="row header">
            <div class="col">{{ "common.startTime" | translate }}</div>
            <div class="col">{{ "common.endTime" | translate }}</div>
            <div class="col grow">
              {{ "common.total" | translate }}:
              {{ this.tools.calculateHours(report.workingTimes) }}
            </div>
          </div>
          @for (entry of report.workingTimes;track entry; let i = $index) {
          <div class="row">
            <div class="col">
              <lib-date-time-picker
                [type]="'time'"
                [inputDateZulu]="entry.start"
                (selectedDateChanged)="
                  timeEntryStartChanged(entry, $event, report)
                "
              ></lib-date-time-picker>
            </div>
            <div class="col">
              <lib-date-time-picker
                [type]="'time'"
                [hourDelay]="1"
                [inputDateZulu]="entry.end"
                (selectedDateChanged)="
                  timeEntryEndChanged(entry, $event, report)
                "
              ></lib-date-time-picker>
            </div>
            <div class="col grow">
              <ion-icon
                style="font-size: 22px; margin-top: 5px; cursor: pointer"
                (click)="removeTimeEntry(report.workingTimes, i)"
                name="trash-outline"
              ></ion-icon>
            </div>
          </div>
          }
        </div>
        <div style="margin: 4px 0 0 6px">
          <ion-button
            fill="outline"
            (click)="addTimeEntry(report.workingTimes, report)"
            ><ion-icon name="add-outline" slot="start"></ion-icon
            >{{ "reports.addTimeEntry" | translate }}</ion-button
          >
        </div>
      </div>
      @if(reportType == ConstructionDayReportType.$0){
      <div class="select-form">
        <lib-user-picker
          [users]="this.state.users$"
          [multiple]="true"
          (selectedUserChanged)="workerChange($event, report)"
          [preselectedUsers]="report.workers"
        ></lib-user-picker>
      </div>
      @if(report.workers?.length > 0){ @for(worker of report.workers;track
      worker){
      <div class="box-header">
        {{
          "reports.workingTimeForEmployee"
            | translate
              : { name: this.state.getUserDisplayNameAsync(worker) | async }
        }}
      </div>
      <div class="working-hours">
        @if (userHasOtherConSiteWorkingTimes(worker, report)) {
        <div class="other-bookings">
          <div>{{ "reports.alreadyBooked" | translate }}</div>
          @for (entry of getOtherConSiteWorkingTimes(worker, report); track
          entry) {
          <div>
            {{ entry }}
          </div>
          }
        </div>
        } @if (userHasWorkingTimes(worker, report)) {
        <div class="suggestions">
          @for (entry of getThisConSiteWorkingTimes(worker, report); track
          entry) {
          <div class="wide">
            <div>{{ getBeautifiedString(entry) }}</div>
            <ion-button (click)="takeUserHours(worker, entry, report)">{{
              "reports.adoptHours" | translate
            }}</ion-button>
          </div>
          }
        </div>
        }

        <div class="custom-table">
          <div class="row header">
            <div class="col">{{ "common.startTime" | translate }}</div>
            <div class="col">{{ "common.endTime" | translate }}</div>
            <div class="col grow">
              {{ "common.total" | translate }}:
              {{ this.tools.calculateHours(report.workerTimeEntries[worker]) }}
            </div>
          </div>
          @for (entry of report.workerTimeEntries[worker];track entry;let i =
          $index) {
          <div class="row">
            <div class="col">
              <lib-date-time-picker
                [type]="'time'"
                [inputDateZulu]="entry.start"
                (selectedDateChanged)="
                  timeEntryStartChanged(entry, $event, report)
                "
              ></lib-date-time-picker>
            </div>
            <div class="col">
              <lib-date-time-picker
                [type]="'time'"
                [inputDateZulu]="entry.end"
                (selectedDateChanged)="
                  timeEntryEndChanged(entry, $event, report)
                "
              ></lib-date-time-picker>
            </div>
            <div class="col grow">
              <ion-icon
                style="font-size: 22px; margin-top: 5px"
                (click)="removeTimeEntry(report.workerTimeEntries[worker], i)"
                name="trash-outline"
              ></ion-icon>
            </div>
          </div>
          }
        </div>
        <div style="margin: 4px 0 0 6px">
          <ion-button
            fill="outline"
            (click)="addTimeEntry(report.workerTimeEntries[worker], report)"
            ><ion-icon name="add-outline" slot="start"></ion-icon
            >{{ "reports.addTimeEntry" | translate }}</ion-button
          >
          <div style="margin: 2px 0 0 2px">
            @if(report.workerTimeEntries[worker].length == 0){
            <div>
              {{ "reports.employeeTimeEntriesMissing" | translate }}
            </div>
            }
            @if(this.tools.timeEntriesInvalid(report.workerTimeEntries[worker])){
            <div>{{ "reports.endBeforeStartError" | translate }}</div>
            } @if(this.timeCollisionDetected(worker, report)){
            <div>
              {{ "reports.bookedTimeOverlapError" | translate }}
            </div>
            }
          </div>
        </div>
      </div>
      } }
      <div class="select-row">
        <ion-select
          [label]="'reports.weather' | translate"
          label-placement="floating"
          mode="md"
          fill="outline"
          interface="popover"
          multiple
          [(ngModel)]="report.weather"
        >
          @for (weatherOption of this.weatherOptions; track weatherOption) {
          <ion-select-option [value]="weatherOption">{{
            weatherOption
          }}</ion-select-option>
          }
        </ion-select>
        <ion-input
          labelPlacement="floating"
          fill="outline"
          mode="md"
          [label]="'reports.temperature' | translate"
          type="number"
          [(ngModel)]="report.temperatureInCelsius"
          pattern="-?[0-9]+"
        >
        </ion-input>
      </div>

      <div class="select-row">
        <ion-input
          labelPlacement="floating"
          fill="outline"
          mode="md"
          [label]="'reports.electricityForm' | translate"
          type="number"
          [(ngModel)]="report.electricityUsedInKWH"
        >
        </ion-input>
        <ion-input
          labelPlacement="floating"
          fill="outline"
          type="number"
          mode="md"
          [label]="'reports.waterForm' | translate"
          [(ngModel)]="report.waterUsedInCubicMeters"
        ></ion-input>
      </div>

      <div class="select-form">
        <ion-checkbox
          stlye="margin-bottom:10px"
          [(ngModel)]="report.securityCheck"
          (ionChange)="checkForInvalidFields()"
          >{{ "reports.securityCheckLabel" | translate }}</ion-checkbox
        >
      </div>
      }
      <div class="select-form">
        <ion-textarea
          [label]="'reports.results' | translate"
          labelPlacement="floating"
          fill="outline"
          [(ngModel)]="report.report"
          mode="md"
          [placeholder]="'common.addText' | translate"
          [autoGrow]="true"
          (ionInput)="checkForInvalidFields()"
        ></ion-textarea>
      </div>
      @if(reportType == ConstructionDayReportType.$0){
      <div class="select-form">
        <ion-textarea
          [label]="'reports.rapport' | translate"
          labelPlacement="floating"
          mode="md"
          fill="outline"
          [(ngModel)]="report.rapport"
          [placeholder]="'common.addText' | translate"
          [autoGrow]="true"
        ></ion-textarea>
      </div>

      <div class="select-form">
        <ion-textarea
          [label]="'reports.difficulties' | translate"
          labelPlacement="floating"
          mode="md"
          fill="outline"
          [(ngModel)]="report.difficulties"
          [placeholder]="'common.addText' | translate"
          [autoGrow]="true"
        ></ion-textarea>
      </div>

      <div class="select-form">
        <ion-textarea
          [label]="'reports.incidents' | translate"
          labelPlacement="floating"
          mode="md"
          fill="outline"
          [(ngModel)]="report.specialIncidents"
          [placeholder]="'common.addText' | translate"
          [autoGrow]="true"
        ></ion-textarea>
      </div>
      <div class="box-header">{{ "reports.machineUsage" | translate }}</div>
      <div class="working-hours">
        @for(machine of report.machineUsages; track machine; let idx = $index){
        <div class="separated-entry">
          <div class="wide">
            <lib-machine-picker
              style="width: 100%"
              [preselectedItem]="machine.id ?? ''"
              [items]="state.machines$"
              [required]="true"
              (selectedItemChanged)="
                selectedMachineChanged($event, machine, report)
              "
            ></lib-machine-picker>
            <ion-icon
              style="font-size: 28px; margin: 0 8px"
              name="trash-outline"
              (click)="removeMachine(report, idx)"
            ></ion-icon>
          </div>
          <div class="wide" style="margin: 5px 0">
            <ion-input
              labelPlacement="floating"
              fill="outline"
              mode="md"
              [label]="'reports.hours' | translate"
              type="number"
              required
              [(ngModel)]="machine.usageInHours"
              (ionInput)="checkForInvalidFields()"
              pattern="^[0-9]+([,.][0-9]+)?$"
              style="margin-right: 5px; max-width: 90px"
            >
            </ion-input>
            <ion-textarea
              [label]="'common.description' | translate"
              labelPlacement="floating"
              mode="md"
              fill="outline"
              [(ngModel)]="machine.description"
              [placeholder]="'common.addText' | translate"
              [autoGrow]="true"
            ></ion-textarea>
          </div>
        </div>
        }
        <ion-button fill="outline" (click)="addMachine(report)"
          ><ion-icon name="add-outline" slot="start"></ion-icon
          >{{ "reports.addMachine" | translate }}</ion-button
        >
      </div>
      <div class="box-header">{{ "reports.rentalMachines" | translate }}</div>
      <div class="working-hours">
        @for(machine of report.rentalMachines; track machine; let idx = $index){

        <div class="separated-entry">
          <div class="wide">
            <lib-select-search
              [label]="'reports.nameType' | translate"
              [items]="rentalMachineOptions"
              [allowCustom]="true"
              [required]="true"
              style="width: 100%"
              [(ngModel)]="machine.name"
              (ngModelChange)="checkForInvalidFields()"
            ></lib-select-search>
            <ion-icon
              style="font-size: 28px; margin: 0 8px"
              name="trash-outline"
              (click)="removeRentalMachine(report, idx)"
            ></ion-icon>
          </div>
          <div class="wide" style="margin: 4px 0 6px 0">
            <ion-input
              labelPlacement="floating"
              fill="outline"
              mode="md"
              [label]="'reports.hours' | translate"
              (ionInput)="checkForInvalidFields()"
              type="number"
              required
              [(ngModel)]="machine.usageInHours"
              pattern="^[0-9]+([,.][0-9]+)?$"
              style="margin-right: 5px; max-width: 90px"
            >
            </ion-input>
            <ion-textarea
              [label]="'common.description' | translate"
              labelPlacement="floating"
              mode="md"
              fill="outline"
              [(ngModel)]="machine.description"
              [placeholder]="'common.addText' | translate"
              [autoGrow]="true"
            ></ion-textarea>
          </div>
        </div>

        }
        <ion-button fill="outline" (click)="addRentalMachine(report)"
          ><ion-icon name="add-outline" slot="start"></ion-icon
          >{{ "reports.addRentalMachine" | translate }}</ion-button
        >
      </div>
      <div class="box-header">{{ "reports.material" | translate }}</div>
      <div class="working-hours">
        @for(consumption of report.materialConsumption; track consumption; let
        idx = $index){

        <div class="separated-entry">
          <div class="wide">
            <lib-select-search
              [label]="'reports.nameType' | translate"
              [items]="materialOptions"
              [allowCustom]="true"
              [required]="true"
              style="width: 100%"
              [(ngModel)]="consumption.name"
              (ngModelChange)="checkForInvalidFields()"
            ></lib-select-search>
            <ion-icon
              style="font-size: 28px; margin: 0 8px"
              name="trash-outline"
              (click)="removeMaterialConsumption(report, idx)"
            ></ion-icon>
          </div>
          <div class="wide" style="margin: 6px 0 6px 0">
            <ion-input
              labelPlacement="floating"
              fill="outline"
              mode="md"
              [label]="'reports.quantity' | translate"
              type="number"
              (ionInput)="checkForInvalidFields()"
              required
              [(ngModel)]="consumption.amount"
              pattern="^[0-9]+([,.][0-9]+)?$"
              style="margin-right: 5px; min-width: 100px"
            >
            </ion-input>
            <lib-unit-picker
              style="margin-right: 5px; min-width: 100px"
              (selectedItemChanged)="unitChanged($event, consumption)"
              [preselectedItem]="consumption.unit"
            ></lib-unit-picker>
            @if(state.isBigScreen){
            <ion-input
              labelPlacement="floating"
              fill="outline"
              mode="md"
              [label]="'reports.supplier' | translate"
              type="text"
              [(ngModel)]="consumption.supplier"
            >
            </ion-input>
            }
          </div>
          @if(!state.isBigScreen){
          <div class="wide" style="margin: 6px 0 6px 0">
            <ion-input
              labelPlacement="floating"
              fill="outline"
              mode="md"
              [label]="'reports.supplier' | translate"
              type="text"
              [(ngModel)]="consumption.supplier"
            >
            </ion-input>
          </div>
          }
        </div>
        }
        <ion-button fill="outline" (click)="addMaterialConsumption(report)"
          ><ion-icon name="add-outline" slot="start"></ion-icon
          >{{ "reports.addMaterial" | translate }}</ion-button
        >
      </div>
      } }@if(uploadRequests[reportIndex] == null ||
      uploadRequests[reportIndex].length == 0){
      <div class="select-form">
        <ion-button (click)="openFileInput(reportIndex)"
          ><ion-icon
            name="cloud-upload-outline"
            slot="start"
            class="white"
          ></ion-icon
          >{{ "common.addDocuments" | translate }}</ion-button
        >
      </div>
      }

      <lib-upload
        (filesChanged)="setUploadFiles($event, reportIndex)"
        (uniqueIdChanged)="setUniqueId($event, reportIndex)"
        [constructionDayReportId]="reportId"
        [displayName]="'reports.thisReport' | translate"
      ></lib-upload>
      @if(attachedNodeItems.length > 0 && nodeItemsToDelete.length !=
      attachedNodeItems.length){

      <div class="select-form">
        <div>{{ "common.documents" | translate }}</div>
        @for(doc of attachedNodeItems; track doc.id){
        @if(!nodeItemsToDelete.includes(doc.id)){
        <div class="wide document">
          <div class="centered">
            <ion-icon
              [name]="state.getIcon(doc)"
              style="margin-right: 5px"
            ></ion-icon>
            <div>{{ doc.displayName }}</div>
          </div>
          <ion-icon
            name="trash-outline"
            class="red"
            (click)="deleteNodeItem(doc.id)"
          ></ion-icon>
        </div>
        } }
      </div>
      }
    </div>

    } @if(errorList.length > 0){
    <div class="error-container">
      @for (error of errorList;track $index) {
      <div class="error-list danger">
        {{ error }}
      </div>
      }
    </div>
    }
    <div class="bottom-buttons">
      @if(this.reportId == null){
      <ion-button (click)="addNewReport()">
        <ion-icon name="add-outline" slot="start"></ion-icon>
        {{
          "reports.addAnotherReport" | translate : { report: reportTypeLabel }
        }}</ion-button
      >
      <ion-button fill="outline" (click)="createDraft()"
        ><ion-icon slot="start" name="document-text-outline"></ion-icon
        >@if(reports.length > 1){ {{ "reports.saveDrafts" | translate }} }@else{
        {{ "reports.saveDraft" | translate }} }</ion-button
      >
      } @if (this.reportId != null && this.reports[0].isDraft) {
      <ion-button fill="outline" (click)="createDraft()">{{
        "reports.updateDraft" | translate
      }}</ion-button>
      } @if (this.reportId == null || this.reports[0].isDraft) {
      <ion-button
        color="success"
        [disabled]="errorList.length > 0 || sendButtonDisabled"
        (click)="sendToBackend()"
        ><ion-icon slot="start" name="paper-plane-outline"></ion-icon
        >{{
          "reports.submitReport" | translate : { report: reportTypeSubmitLabel }
        }}</ion-button
      >
      } @if (this.reportId != null && !this.reports[0].isDraft) {
      <ion-button [disabled]="errorList.length > 0" (click)="sendToBackend()">{{
        "reports.updateReport" | translate : { report: reportTypeLabel }
      }}</ion-button>
      }
    </div>
  </div>
</ion-content>
